import Vue from 'vue';
import { get } from '@/shared/utils/utils';

export default class AppComponent extends Vue {
    private readonly DefaultLayout = 'default';

    get layout() {
        const layout = this.$route.matched
            .map(p => get(p, 'meta.layout'))
            .filter(p => p !== undefined)
            .reduce<string>((result, current) => current, this.DefaultLayout)

        return `${layout}-layout`;
    }
}
